import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMiniCheck = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.2493 7.87635C16.6628 8.15207 16.7746 8.71085 16.4989 9.12442L11.9989 15.8744C11.8493 16.0988 11.607 16.2442 11.3387 16.2708C11.0704 16.2974 10.8043 16.2022 10.6136 16.0116L7.61364 13.0116C7.26217 12.6601 7.26217 12.0903 7.61364 11.7388C7.96511 11.3873 8.53496 11.3873 8.88643 11.7388L11.1102 13.9625L15.0012 8.12596C15.2769 7.71239 15.8357 7.60063 16.2493 7.87635Z",
		fill: "currentcolor"
	})]
});
export default SvgMiniCheck;
